// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components

// ----------------------------------------------------------------------

const navConfig = [
  {
    subheader: 'Cases',
    items: [
      { title: 'List', path: PATH_DASHBOARD.cases.list, rights: ['read_case'] },
      { title: 'Excluded', path: PATH_DASHBOARD.cases.excluded, rights: ['read_case'] },
      { title: 'Archived', path: PATH_DASHBOARD.cases.archived, rights: ['read_case'] },
    ],
  },
  {
    subheader: 'Tasks',
    items: [
      { title: 'List', path: PATH_DASHBOARD.tasks.list, rights: ['read_task'] },
    ],
  },
  {
    subheader: 'MinOmx',
    items: [
      { title: 'List', path: PATH_DASHBOARD.minomx.list, rights: ['minomx'] },
    ],
  },
  {
    subheader: 'Import',
    items: [
      { title: 'Upload', path: PATH_DASHBOARD.cases.upload, rights: ['upload_case'] },
      { title: 'PACS', path: PATH_DASHBOARD.cases.pacs, rights: ['import_pacs'] },
    ],
  },
  {
    subheader: 'Admin user',
    items: [
      { title: 'List User', path: PATH_DASHBOARD.admin.users.list, rights: ['list_user'] },
      { title: 'Create User', path: PATH_DASHBOARD.admin.users.new, rights: ['create_user'] },
    ],
  },
  {
    subheader: 'Admin',
    items: [
      { title: 'Audit log', path: PATH_DASHBOARD.admin.auditLog, rights: ['read_audit_log'] }
    ],
  },
  {
    subheader: 'Links',
    items: [
      { title: 'CVD Form', path: 'https://docs.google.com/forms/d/e/1FAIpQLSeoh8ArOSC1zoSU-RLCiePB4mdcTaWBLzd__mUHrA-cYSKwPw/viewform' },
      { title: 'Privacy Policy', path: 'https://docs.google.com/document/u/2/d/e/2PACX-1vRfHZ_P5eE3dj5Ex5JPzcqjNmELIeSt6TOhhGqSTIWPF5sWdaUFYW9J6CxCcGBdDv2NzBKvO-IPq0KG/pub' },
      { title: 'Documentation', path: 'https://www.pmxinc.ai/94' },
    ],
  },
];

export default navConfig;
